import * as PracticeAreasFeaturesPracticeAreaUploads from "$lib/data/generated/uploads/practice areas/Features Practice Area/uploads.js";
import * as PracticeAreasFeaturesPracticeAreaAsideUploads from "$lib/data/generated/uploads/practice areas/Features Practice Area Aside/uploads.js";
import * as PracticeAreasFeaturesServicesGridUploads from "$lib/data/generated/uploads/practice areas/Features Services Grid/uploads.js";
import * as PracticeAreasHeadUploads from "$lib/data/generated/uploads/practice areas/Head/uploads.js";
import * as PracticeAreasHeadPracticeAreaUploads from "$lib/data/generated/uploads/practice areas/Head Practice Area/uploads.js";
import * as PracticeAreasMarkedContentPracticeAreaUploads from "$lib/data/generated/uploads/practice areas/MarkedContent Practice Area/uploads.js";
import * as PracticeAreasPageBannerUploads from "$lib/data/generated/uploads/practice areas/PageBanner/uploads.js";
import * as PracticeAreasPageBannerPracticeAreaUploads from "$lib/data/generated/uploads/practice areas/PageBanner Practice Area/uploads.js";
import * as PracticeAreasRelatedArticlesPracticeAreaUploads from "$lib/data/generated/uploads/practice areas/RelatedArticles Practice Area/uploads.js";
import * as PracticeAreasTOCPracticeAreaUploads from "$lib/data/generated/uploads/practice areas/TOC Practice Area/uploads.js";

export const uploads = {
  ...PracticeAreasFeaturesPracticeAreaUploads.uploads,
  ...PracticeAreasFeaturesPracticeAreaAsideUploads.uploads,
  ...PracticeAreasFeaturesServicesGridUploads.uploads,
  ...PracticeAreasHeadUploads.uploads,
  ...PracticeAreasHeadPracticeAreaUploads.uploads,
  ...PracticeAreasMarkedContentPracticeAreaUploads.uploads,
  ...PracticeAreasPageBannerUploads.uploads,
  ...PracticeAreasPageBannerPracticeAreaUploads.uploads,
  ...PracticeAreasRelatedArticlesPracticeAreaUploads.uploads,
  ...PracticeAreasTOCPracticeAreaUploads.uploads
};
